import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'settings.custom-fields.field-index-table.name';
    property = 'name';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
